// Appels de connexion au serveur (étape d). Chaque fonction renvoie la réponse du serveur, ou
// lève une erreur dont le message est prêt à afficher.
export function creerSession({ base = "" } = {}) {
  async function appel(chemin, { methode = "POST", corps } = {}) {
    let rep;
    try {
      rep = await fetch(`${base}${chemin}`, {
        method: methode,
        credentials: "same-origin",
        headers: corps ? { "Content-Type": "application/json" } : {},
        body: corps ? JSON.stringify(corps) : undefined,
      });
    } catch (e) {
      throw new Error("Le serveur de l'ERP ne répond pas. Vérifie ta connexion internet et réessaie.");
    }
    const r = await rep.json().catch(() => ({}));
    if (!rep.ok) {
      const err = new Error(r.message || `Erreur du serveur (${rep.status}).`);
      err.statut = rep.status;
      throw err;
    }
    return r;
  }
  return {
    // { etape, compte } ; null si personne n'est connecté.
    async moi() {
      try {
        return await appel("/api/moi", { methode: "GET" });
      } catch (e) {
        if (e.statut === 401) return null;
        throw e;
      }
    },
    connexion: (identifiant, motDePasse) => appel("/api/connexion", { corps: { identifiant, motDePasse } }),
    choisirMotDePasse: (motDePasse) => appel("/api/connexion/mot-de-passe", { corps: { motDePasse } }),
    preparerDoubleAuthentification: () => appel("/api/connexion/totp", { methode: "GET" }),
    activerDoubleAuthentification: (code) => appel("/api/connexion/totp", { corps: { code } }),
    saisirCode: (code) => appel("/api/connexion/code", { corps: { code } }),
    genererCode: (id, nom, profil) => appel(`/api/comptes/${encodeURIComponent(id)}/code`, { corps: { nom, profil } }),
    async deconnecter() {
      try {
        await appel("/api/deconnexion");
      } finally {
        window.location.reload();
      }
    },
  };
}
